import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from 'infrastructure/js/components/controls/Button/button';

import './scanInputStandalone.scss';

export default function ScanInputStandalone({
  id,
  name,
  placeholder = '',
  value = '',
  onChange,
  onSubmit,
  disabled = false,
  error = '',
  autoFocus = false,
  selectAll = false,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  //When error changes to a non-empty string the input text is selected,
  //so the next scan or keystroke immediately replaces it
  useEffect(() => {
    if (error && inputRef.current) {
      inputRef.current.select();
    }
  }, [error]);

  useEffect(() => {
    if (selectAll && inputRef.current) {
      inputRef.current.select();
    }
  }, [selectAll]);

  const handleChange = (e) => {
    onChange?.(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && value) {
      e.preventDefault();
      onSubmit?.(value);
    }
  };

  const handleClear = () => {
    onChange?.('');
    inputRef.current?.focus();
  };

  const handleSubmit = () => {
    if (value) {
      onSubmit?.(value);
      inputRef.current?.focus();
    }
  };

  return (
    <div className="scan-input-standalone">
      <div className={cn('barcode-input', { 'has-error': !!error })}>
        <span className="PL-textField">
          <input
            ref={inputRef}
            id={id}
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            disabled={disabled}
            autoComplete="off"
          />
        </span>
        <Button
          id={`${id}-clear`}
          className="only-icon"
          icon="pl pl-x-input-close"
          disabled={disabled || !value}
          onClick={handleClear}
        />
        {onSubmit && (
          <Button
            id={`${id}-submit`}
            className="only-icon submit"
            icon="pl pl-arrow-right"
            disabled={disabled || !value}
            onClick={handleSubmit}
          />
        )}
      </div>
      {!!error && <label className="barcode-input-error">{error}</label>}
    </div>
  );
}

ScanInputStandalone.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  autoFocus: PropTypes.bool,
  selectAll: PropTypes.bool,
};
